/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return ''
  } else if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 替换邮箱字符
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    const str = email.split('@')
    let _s = ''
    if (str[0].length > 3) {
      for (var i = 0; i < str[0].length - 3; i++) {
        _s += '*'
      }
    }
    var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
  }
  return new_email
}

// 替换手机字符
export function regMobile(mobile) {
  if (mobile.length > 7) {
    var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return new_mobile
}

// 下载文件
export function downloadFile(obj, name, suffix) {

  // const url = window.URL.createObjectURL(new Blob([obj]))
  const url='http://www.tgj168.com/wuliu/static/'+obj
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  const fileName = parseTime(new Date()) + '-' + name + '.' + suffix
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 拖拽元素底部 调整高度
export function dragBtn(handle, isTop, headerHeight) {
  handle.onmousedown = function(evt) {
    const event = evt || window.event
    const disY = event.clientY - handle.offsetTop // 鼠标按下时的垂直坐标值 - 句柄顶部距离
    const iParentHeight = window.clientHeight // 窗口高度
    document.onmousemove = function(e) {
      const event1 = e || window.event
      const iT = event1.clientY - disY - handle.offsetHeight // 鼠标移动中 鼠标垂直坐标值 - 差距
      const maxH = document.documentElement.clientHeight - handle.offsetHeight // 最大高度
      let iH = isTop ? handle.offsetHeight + iT : iParentHeight - iT // 拖拽距离
      iH < headerHeight && (iH = headerHeight)
      iH > maxH && (iH = maxH)
      handle.style.top = iH + 'px' // 同时修改父容器height值
      return false
    }
    document.onmouseup = function() {
      document.onmousemove = null
      document.onmouseup = null
    }
    return false
  }
}
//图片地址前缀
export function imgUrl(url,type){
	if (type === "common") {
	  return "https://img.tgj168.com/" + url + "?x-oss-process=style/common";
	}else if (type === "thumb") {
		return "https://img.tgj168.com/" + url + "?x-oss-process=style/thumb"
	}else if (type === "videoUrl") {
		return 'https://www.tgj168.com/index.php?d=wxapi&c=common_oss&m=yunvod_view&yunmediaid=' + url + '&filetype=mp4';
	}else if (type === "videopictureUrl") {
		return 'https://www.tgj168.com/index.php?d=wxapi&c=common_oss&m=yunvod_view&yunmediaid=' + url + '&filetype=cover';
	}else if (type === 'no') {
	  return "http://www.tgj168.com/static/images/avatar/no.jpg";
	}else if (type === 'banner') {
	  return "https://img.tgj168.com/static/images/banner/" + url + "";
	}else if (type === 'share') {
	  return "https://img.tgj168.com/static/images/share/" + url + "?x-oss-process=style/common";
	}else if (type == 'service') {
	  return "https://img.tgj168.com/static/images/service/" + url + "?x-oss-process=style/common";
	}else {
    return "https://img.tgj168.com/" + url;
  }
}
//字符串数据处理
export function extractNumbers(str, type) {
  if(str!=''){
    if (type == 1) {
      return Number(str.match(/\d+/g).join(''));
    } else if (type == 2) {
      return str.match(/\d+/g);
    }else if (type == 3) {
      return str.substr(0,4)+'-'+str.substr(4,2)+'-'+str.substr(6,2);
    }
  }
}

//时间的转换
export const formatime = function (shijianchuo,type,nowdata,num) {
  if(shijianchuo==0){
    return;
  }
  var time;
	if(nowdata=='now'){
	    time= new Date(shijianchuo);
	}else{
	    time = new Date(shijianchuo*1000);
	}
	var y = time.getFullYear();
	var m = time.getMonth()+1;
	var d = time.getDate();
	var h = time.getHours();
	var mm = time.getMinutes();
	var s = time.getSeconds();

	if(type==="ymdhms"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
	}else if(type==="ymdhm"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm);
	}else if(type==="ymd"){
		return add0(y)+'-'+add0(m)+'-'+add0(d);
	}else if(type=="ymdCN"){
		return add0(y)+'年'+add0(m)+'月'+add0(d)+'日';
	}else if(type==="hms"){
		return add0(h)+':'+add0(mm)+':'+add0(s);
	}else if(type==="ymdh"){
		return add0(y)+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+'点';
	}else if(type==="md"){
		return add0(m)+'-'+add0(d);
	}else if(type=="mdCN"){
		return add0(m)+'月'+add0(d)+'日';
	}else if(num>0){
    // console.log(add0(y)+'-'+add0(m)+'-'+add0(d))
    return GetPreMonthDay(add0(y)+'-'+add0(m)+'-'+add0(d),num,type)
	}else if(type=="today"){
    if(num=='totay'){
      time.setDate(shijianchuo.getDate());
    }else{
      time.setDate(shijianchuo.getDate() - 1);
    }
    return {
      value:dateFormatFn(time,'val'),
      text:dateFormatFn(time,'text'),
      num:1
    }
  }else if(type=="week"){
    return {
      value:getLastWeekFn(add0(y)+'-'+add0(m)+'-'+add0(d),'val',num),
      text:getLastWeekFn(add0(y)+'-'+add0(m)+'-'+add0(d),'text',num),
      num:7
    }
  }else if(type=="month"){
    return {
      value:GetMonthDay(add0(y)+'-'+add0(m)+'-'+add0(d),num=='yester'?1:num=='before'?2:0,'val'),
      text:GetMonthDay(add0(y)+'-'+add0(m)+'-'+add0(d),num=='yester'?1:num=='before'?2:0,'text'),
      num:GetMonthDay(add0(y)+'-'+add0(m)+'-'+add0(d),num=='yester'?1:num=='before'?2:0,'daynum')
    }
  }
}
export const getLastWeekFn = function (date,type,num)  {
  let day = new Date(date).getTime();
  //判断传入日期是周几
  let dayCode = new Date(day).getDay() > 0 ? new Date(day).getDay() : 7;
  let dayTime = 24 * 60 * 60 * 1000;
  let Mon = new Date(day - dayTime * (dayCode - 1));//传入时间的周一
  Mon = dateFormatFn(Mon);
  let startDate='',endDate='';
  if(num=='totay'){
    startDate = new Date(new Date(Mon).getTime());
    startDate = dateFormatFn(startDate);
    endDate = new Date(new Date(startDate).getTime() + 6 * dayTime)
    startDate = dateFormatFn(startDate);
  }else{
    endDate = new Date(new Date(Mon).getTime() - dayTime);//上周日
    endDate = dateFormatFn(endDate);
    startDate = new Date(new Date(endDate).getTime() - 6 * dayTime);//上周一
    startDate = dateFormatFn(startDate);
  }
  if(type=='val'){
    return [startDate, endDate]
  }else{
    return dateFormatFn(startDate,'text')+'-'+dateFormatFn(endDate,'text')
  }
}

// 返回月份
export const GetMonthDay = function (date, monthNum,type) {
   var dateArr = date.split("-");
   var year = dateArr[0]; //获取当前日期的年份
   var month = dateArr[1]; //获取当前日期的月份
   var day = dateArr[2]; //获取当前日期的日
   var days = new Date(year, month, 0);
   days = days.getDate(); //获取当前日期中月的天数
   var year2 = year;
   var month2 = parseInt(month) - monthNum;
   if (month2 <= 0) {
       var absM = Math.abs(month2);
       year2 = parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
       month2 = 12 - (absM % 12);
   }
   var day2 = day;
   var days2 = new Date(year2, month2, 0);
   days2 = days2.getDate();
   if (day2 > days2) {
       day2 = days2;
   }
   if (month2 < 10) {
       month2 = "0" + month2;
   }
   var t2 = '';
   if(type=='text'){
      t2=year2+'年'+month2+"月";
   }else if(type=='val'){
      t2=year2 + "-" + month2;
   }else if(type=='daynum'){
     t2=days2;
   }
   return t2;
}

export const dateFormatFn = function (date,type)  {
     let myDate = new Date(date);
     let year = myDate.getFullYear();
     let month = myDate.getMonth() + 1;
     let month1 = myDate.getMonth() + 2;
     let weekday = myDate.getDate();
     if (month < 10) {
       month = "0" + month;
       month1 = "0" + month1;
     }
     if (weekday < 10) {
       weekday = "0" + weekday;
     }
     if(type=='text'){
       return month + "月" + weekday+'日';
     }else if(type=='y-m'){
       return year + "-" + month;
     }else if(type=='y-m-l'){
       return year + "-" + month + "-" + new Date(year,month,0).getDate();
     }else{
       return year + "-" + month + "-" + weekday;
     }
}



//返回往前日期
export const GetPreMonthDay = function (date, monthNum,type) {
   var dateArr = date.split("-");
   var year = dateArr[0]; //获取当前日期的年份
   var month = dateArr[1]; //获取当前日期的月份
   var day = dateArr[2]; //获取当前日期的日
   var days = new Date(year, month, 0);
   days = days.getDate(); //获取当前日期中月的天数
   var year2 = year;
   var month2 = parseInt(month) - monthNum;
   if (month2 <= 0) {
       var absM = Math.abs(month2);
       year2 = parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
       month2 = 12 - (absM % 12);
   }
   var day2 = day;
   var days2 = new Date(year2, month2, 0);
   days2 = days2.getDate();
   if (day2 > days2) {
       day2 = days2;
   }
   if (month2 < 10) {
       month2 = "0" + month2;
   }
   var t2 = '';
   if(type=='y年m月'){
      t2=year2+'年'+month2+"月";
   }else if(type=='y-m'){
      t2=year2 + "-" + month2;
   }else if(type=='daynum'){
     t2=days;
   }
   return t2;
}
export const add0 = function (m) {
	return m<10?'0'+m:m
}
//车辆警报
export const isPolice = function (index) {
    var list=[
        "紧急报警",
        "超速报警",
        "疲劳驾驶报警",
        "危险驾驶行为报警",
        "GNSS 模块发生故障报警",
        "GNSS 天线未接或被剪断报警",
        "GNSS 天线短路报警",
        "终端主电源欠压报警",
        "终端主电源掉电报警",
        "终端 LCD 或显示器故障报警",
        "TTS 模块故障报警",
        "摄像头故障报警",
        "道路运输证IC 卡模块故障报警",
        "超速预警",
        "疲劳驾驶预警",
        "违规行驶报警",
        "胎压预警",
        "右转盲区异常报警",
        "当天累计驾驶超时报警",
        "超时停车报警",
        "进出区域报警",
        "进出路线报警",
        "路段行驶时间不足/过长报警",
        "路线偏离报警",
        "车辆 VSS 故障",
        "车辆油量异常报警",
        "车辆被盗报警",
        "车辆非法点火报警",
        "车辆非法位移报警",
        "碰撞侧翻报警",
        "侧翻预警"
    ]
    return list[index]
}
export const getPoliceType = function (str,data) {
    var text='',isred=0,isrednum=0,isyellow=0,isyellownum=0,isblue=0;
    var num=str?parseInt(str):0
    var lists= (num.toString(2)).toString();
    lists=lists.split("").reverse().join("");

    if(lists=='0'){
        isblue=1

    }else{
        for(var index in lists){
            if(index==1||index==13){
                if(lists[index]=='1'){
                    isred=1;
                    if(isrednum<1){
                        text+='<p>'+isPolice(index)+'</p>';
                    }
                    isrednum++;
                }
            }else {
                if(lists[index]=='1'){
                    if(isyellownum<1){
                        isyellow=1
                    }
                    isyellownum++;
                    text+='<p>'+isPolice(index)+'</p>'
                }
            }
        }

    }

    return {
        isred:isred,
        isblue:isblue,
        isyellow:isyellow,
        text:text,
    }

}
